import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { LOCATION_CHANGE } from "connected-react-router";
import mapCases from "./map-cases";
import identity from "./identity";
import employees from "./employees";
import departments from "./departments";
import upload from "./upload";
import admin from "./admin";
import crmTopics from "./crm_topics";
import crmRequests from "./crm_requests";
import codeTopics from "./ce_topics";
import codeCases from "./code_cases";

const site = (state = {}, action: any) => {
  switch (action.type) {
    case LOCATION_CHANGE:
      return Object.assign({}, state, { site: action.payload.location.pathname.split("/")[1] });
    default:
      return state;
  }
};

export default (history: any) =>
  combineReducers({
    router: connectRouter(history),
    admin,
    site,
    identity,
    employees,
    departments,
    crmTopics,
    codeTopics,
    codeCases,
    crmRequests,
    ...mapCases,
    ...upload,
  });
